import {
    Banner,
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Select,
} from '@ygtechnologies/bygr-frontend-component-library';
import React, { useState } from 'react';
import { DocumentCategoriesDto } from 'services/projects';
interface ProjectSelectCategoriesModalProps {
    values: DocumentCategoriesDto[];
    selectedValue?: number;
    isOpen: boolean;
    onSave(selectedValue: number): Promise<void>;
    toogle: () => void;
}

const ProjectSelectCategoriesModal: React.FC<ProjectSelectCategoriesModalProps> = ({
    isOpen,
    onSave,
    values,
    selectedValue,
    toogle,
}) => {
    const [showWarning, setShowWarning] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const options = values.map((x) => {
        return { value: x.id, label: x.name };
    });
    const [selValue, setSelValue] = useState(options.find((x) => x.value === selectedValue) || null);
    const save = async () => {
        if (selValue) {
            setIsSaving(true);
            await onSave(selValue.value);
            setIsSaving(false);
        } else {
            setShowWarning(true);
        }
    };

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader>Select document category hierarchy</ModalHeader>
            <ModalBody>
                <Select options={options} value={selValue} onChange={(x: any) => setSelValue(x)} />
                {showWarning && <Banner type="danger">You have to pick a category to continue.</Banner>}
            </ModalBody>
            <ModalFooter>
                <Button color="tertiary" onClick={toogle}>
                    Cancel
                </Button>
                <Button color="primary" onClick={save} loading={isSaving}>
                    Save
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ProjectSelectCategoriesModal;
